export default __webpack_public_path__ + "static/ceo-blog-content-Img-6a277c63d5fdb6c61bdde0150e69d9ff.jpeg";